import React, { createContext, useState, useContext, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

// Create a new context for authentication state
const AuthStateContext = createContext();

// Custom hook to access authentication state
export const useAuthState = () => useContext(AuthStateContext);

// Create AuthStateProvider component
export const AuthStateProvider = ({ children }) => {
  const [user, setUser] = useState({
    token: localStorage.getItem("authToken") || null,
    fullName: localStorage.getItem("fullName") || null,
  });
  const [pendingBooking, setPendingBooking] = useState({});

  useEffect(() => {
    var token = localStorage.getItem("authToken");
    if (token) {
      const decoded = jwtDecode(token); // Decode JWT token to get user details
      const { exp, cancellationPeriod } = decoded;
      const currentTime = Date.now() / 1000; // in seconds

      if (exp < currentTime) {
        setUser({ token: null, fullName: null, cancellationPeriod: null });
        localStorage.removeItem("authToken");
        localStorage.removeItem("fullName");
      } else {
        setUser({
          token: localStorage.getItem("authToken") || null,
          fullName: localStorage.getItem("fullName") || null,
          cancellationPeriod: cancellationPeriod,
        });
      }
    }
  }, []);
  // Login function: Decode the token and save user details
  const login = (token) => {
    const decoded = jwtDecode(token); // Decode JWT token to get user details
    const { fullName, cancellationPeriod } = decoded; // Extract the full name

    // Update state
    setUser({
      token: token,
      fullName: fullName,
      cancellationPeriod: cancellationPeriod,
    });

    // Save token and full name to localStorage
    localStorage.setItem("authToken", token);
    localStorage.setItem("fullName", fullName);
  };

  // Logout function: Clear user data from state and localStorage
  const logout = () => {
    setUser({ token: null, fullName: null, cancellationPeriod: null });
    localStorage.removeItem("authToken");
    localStorage.removeItem("fullName");
  };

  return (
    <AuthStateContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        pendingBooking,
        setPendingBooking,
      }}
    >
      {children}
    </AuthStateContext.Provider>
  );
};
